import Container from './container'

export default function SolucoesTecnologicas() {
  return (
    <section className="bg-[#040116] text-white">
      <Container className="lg:max-w-[1240px] text-center md:text-left py-14 md:py-28 flex flex-col md:flex-row items-center justify-between space-y-7 md:gap-4">
        <article className="w-full text-3xl lg:text-[48px]">
          <h3 className="lg:leading-14">
            Soluções tecnológicas <br /> de{' '}
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              alta performance
            </span>
          </h3>
        </article>
        <article>
          <p className="text-base lg:text-2xl px-1 md:px-0">
            Alavancamos negócios rumo à eficiência com aplicativos, sistemas e
            plataformas que geram resultados efetivos e impactantes.
          </p>
        </article>
      </Container>
    </section>
  )
}
